// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "8ec394677-dirty",
    "hash": "8ec394677",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "8ec394677-dirty",
    "semverString": null,
    "version": "0.0.0",
    "buildDate": "10/15/2025",
    "buildTime": "Wed, 15 Oct 2025 13:19:34 GMT"
};
/* eslint:enable */
